import { GeneralToggle } from "../../../../../general";

// Values same as in `TimePeriod` enum at the back.
const Period = {
    TODAY: 'today',
    LAST_THREE_DAYS: 'last-three-days',
    LAST_WEEK: 'last-week',
    LAST_MONTH: 'last-month',
    LAST_THREE_MONTHS: 'last-three-months',
    LAST_SIX_MONTHS: 'last-six-months',
    LAST_YEAR: 'last-year',
    ALL: 'all',
}

const periods = [
    {
        title: 'Today',
        value: Period.TODAY,
    },
    {
        title: 'Last 3 Days',
        value: Period.LAST_THREE_DAYS,
    },
    {
        title: 'Last Week',
        value: Period.LAST_WEEK,
    },
    {
        title: 'Last Month',
        value: Period.LAST_MONTH,
    },
    {
        title: 'Last 3 Months',
        value: Period.LAST_THREE_MONTHS,
    },
    {
        title: 'Last 6 Months',
        value: Period.LAST_SIX_MONTHS,
    },
    {
        title: 'Last Year',
        value: Period.LAST_YEAR,
    },
    {
        title: 'All',
        value: Period.ALL,
    },
];

const PeriodToggle = ({ period, setPeriod, historyPeriods }) => {
    const items = periods.filter(item => historyPeriods.includes(item.value));
    return (
        <GeneralToggle 
            label='Period' 
            value={period} 
            setValue={setPeriod}
            items={items}
            fixedMinWidth={true}
        />
    );
}

export default PeriodToggle;